import React, { Component, useMemo } from 'react';
import Navbar from './Navbar';
import Sidebar from './Sidebar';
import styled from 'styled-components';
import MainContent from './MainContent';

const MainPageCompenent = (props) => {
    const Container = styled.div`
        width: 80%;
        background: linear-gradient(to bottom right,white 0% right, #e6e4ff 70%);
        border-radius: 2rem 0 2rem 0;
        margin:5px 30px;        
        @media screen and (min-width: 1081px) and (max-width: 1920px){
            width: 75%;
        }
        @media screen and (min-width: 320px) and (max-width: 1080px){
            width: 100%;
            margin:5px 5px;
        }
    `;
    const MainComponent = useMemo(() => props.children);
    return (
        <>
            <Sidebar />
            <Container>
                <Navbar />
                {MainComponent}
            </Container>
        </>
    );
}

export default MainPageCompenent;